import { useState } from "react";

import type { GoodsInfoParamsType } from '@/pages/order-center/components/goods-info'
import type { GoodsInfoType } from "@/pages/order-center/type";

/** 将详情的 GoodsInfoType(camelCase) 转为接口所需的 GoodsInfoParamsType(snake_case) */
export function formatGoodsInfoToParams(
  desc: string,
  data?: GoodsInfoType,
): GoodsInfoParamsType {
  return {
    goods: data?.goods?.map(item => ({
      enum_id: item.enumId,
      enum_name: item.enumName,
    })) || [],
    packet: data?.packet?.map(item => ({
      enum_id: item.enumId,
      enum_name: item.enumName,
    })) || [],
    move_id: data?.moveId,
    move_name: data?.moveName,
    desc,
    tag: {
      length: data?.tag?.length,
      width: data?.tag?.width,
      height: data?.tag?.height,
      weight: data?.tag?.weight,
      volume: data?.tag?.volume,
      weight_show: {
        enum_id: data?.tag?.weightShow?.enumId,
        enum_name: data?.tag?.weightShow?.enumName,
      },
    },
  };
}

export default function OrderCenterSameCityUseCarGoodsInfo() {
  const [goodsdata, setGoodsData] = useState<GoodsInfoParamsType>();

  const set = ({ desc, data }: { desc: string; data?: GoodsInfoType }) => {
    setGoodsData(formatGoodsInfoToParams(desc, data));
  }

  // 清空货物信息
  const reset = () => {
    setGoodsData(undefined);
  }

  return {
    goodsdata,
    setGoodsData,
    set,
    reset,
  }
}